import MarkSvg from '@/assets/brand/stratifai-mark.svg?react';
import TextSvg from '@/assets/brand/stratifai-text.svg?react';

/**
 * Logo components — the underlying SVGs use `fill: currentColor`, so callers
 * control the color with a Tailwind text class (e.g. `text-white`, `text-ink`).
 * `aria-label` is forwarded so callers give the mark an accessible name.
 */
interface LogoPartProps {
  className?: string;
  'aria-label'?: string;
  'aria-hidden'?: boolean;
}

export function LogoIcon({ className = '', ...aria }: LogoPartProps) {
  return <MarkSvg role="img" className={className} {...aria} />;
}

export function LogoText({ className = '', ...aria }: LogoPartProps) {
  return <TextSvg role="img" className={className} {...aria} />;
}
